// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAfYvsWwaXQs0oSaIwit1xwFrSlBT1AnzM',
    authDomain: 'spaia-9d111.firebaseapp.com',
    databaseURL: 'https://spaia-9d111.firebaseio.com',
    projectId: 'spaia-9d111',
    storageBucket: 'spaia-9d111.appspot.com',
    messagingSenderId: '922702952552',
    appId: '1:922702952552:web:b3e64214a7c718399da3dd',
    measurementId: 'G-MP73FCCCD6',
  },
  apiUrl: 'https://dev-api.spaia.earth',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
